module.exports = __webpack_public_path__ + "static/media/dochilove04.3d1828c8.jpg";